<template>
    <div class="container">
        <div class="login-box">
            <el-image class="left-bg-img" :src="require('@/assets/static/login-left-bg.jpg')" fit="cover" :lazy="true"></el-image>
            <el-row>
                <el-col class="left-box" :span="15" :offset="0">
                    <!-- <div class="slogan">
                        <p class="text">一站式房态管理</p>
                    </div> -->
                    <div class="join">
                        <el-row >
                            <el-col :span="18" :offset="0">
                                <p class="text join-title">更简单、更全面</p>
                            </el-col>
                            <el-col :span="6" :offset="0">
                                <div class="line"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <p class="text company">乐宿网络科技有限公司出品</p>
                </el-col>
                <el-col class="login-warp" :span="9" :offset="0">
                    <div class="login-info">
                        <!-- <div class="brand-logo">
                            <el-image class="brand-img" :src="require('@/assets/static/81704678610148eb548bd06d1c0dd9f.png')" fit="fill" :lazy="true"></el-image>
                        </div> -->
                        <p class="text title">慧租房管理系统</p>
                        <div class="form-box">
                            <el-form label-width="0" :inline="false" size="normal">
                                <el-form-item label="">
                                    <el-input class="custom-input" v-model="account" prefix-icon="el-icon-user"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input class="custom-input" type="password" v-model="password" prefix-icon="el-icon-unlock"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button class="btn" type="danger" @click="confirm">登录</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <router-link class="text" to="/">忘记密码?</router-link>
                        <router-link class="text register-text" to="/register">没有账号，立即注册</router-link>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            account: '',
            password: '',
        }
    },
    methods: {
        confirm() {
            var params = {
                name: this.account,
                pwd: this.password,
                LodingType: 'pwd',
            }
            this.$api.login(params)
                .then(data=>{
                    var {uid, userType, token, permission, name, groupName, sub_type} = data;
                    this.$store.commit('setuser', data);
                    this.$store.commit('settoken', token);
                    this.$store.commit('setuid', uid);
                    this.$store.commit('setuserType', userType);
                    this.$store.commit('setpermission', permission);
                    this.$store.commit('setuserName', name);
                    this.$store.commit('setsubType', sub_type);
                    this.$store.commit('setgroupName', groupName);
                    this.$router.push({path: '/police/house/list'});
                })
            
        }
    },
}
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
    height: 100vh;
    background: #303133;
    overflow: hidden;
    display: flex;
    justify-content:center;
    align-items: center;
}
.login-box{
    width: 1010px;
    height: 590px;
    border-radius: 4px;
    box-shadow: 4px 4px 5px 1px #303133;
    overflow: hidden;
    position: relative;
    .left-bg-img{
        width: 100%;
        height: 590px;
        background: #444;
        position: absolute;
    }
    .slogan{
        font-size: 22px;
        font-weight: bold;
        // margin-top: 180px;
        // margin-left: 47px;
        line-height: 30px;
        color: #fff;
        background: rgba($color: #333, $alpha: 0.6);
        position: absolute;
        bottom: 80px;
        right: 10px;
    }
    .left-box{
        position: relative;
        height: 590px;
        .join{
            position: absolute;
            right: 20px;
            bottom: 20px;
            width: 200px;
            .join-title{
                border-bottom: 1px solid #fff;
                margin-bottom: 6px;
                line-height: 28px;
            }
            .text{
                font-size: 16px;
                color: #fff;
                text-align: center;
            }
            .line{
                width: 100%;
                height: 1px;
                background: #fff;
                margin-top: 14px;
            }
        }
        .company{
            position: absolute;
            bottom: 20px;
            left: 20px;
            font-size: 10px;
            color: #82848a;
        }
    }
    
    .login-warp{
        position: relative;
        z-index: 2;
        height: 590px;
        overflow: hidden;
        &::after{
            content: "";
            position: absolute;
            right: 0;
            top: 0;
            /* 固定模糊层位置 */
            width: 1010px;
            height: 600px;
            background-image: url('../../assets/static/login-left-bg.jpg');
            filter: blur(15px);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            /* 值越大越模糊 */
            z-index: 1;
        }
        .login-info{
            position: relative;
            z-index: 2;
            overflow: hidden;
            height: 590px;
            .text{
                color: #fff;
                text-align: center;
                width: 100%;
                display: inline-block;
            }
            .text.register-text{
                text-align: right;
                box-sizing: border-box;
                padding-right: 20px;
                position: absolute;
                bottom: 20px;
                right: 0;
            }
            .title{
                font-size: 28px;
                margin-top: 82px;
                font-weight: bold;
            }
            
            .form-box{
                width: 280px;
                margin-left: 50%;
                transform: translateX(-140px);
                margin-top: 100px;
                .custom-input{
                    /deep/ .el-input__inner{
                        text-align: center;
                        background: transparent;
                        border: none;
                        border-bottom: 1px solid #fff;
                        border-radius: 0;
                        color: #fff;
                    }
                }
                .btn{
                    width: 100%;
                    border-radius: 0;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>